import { render, staticRenderFns } from "./deviceInfo.vue?vue&type=template&id=56706f02"
import script from "./deviceInfo.vue?vue&type=script&lang=js"
export * from "./deviceInfo.vue?vue&type=script&lang=js"
import style0 from "./deviceInfo.vue?vue&type=style&index=0&id=56706f02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports